import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { getObjFromId } from '../../../utils/directusFunctions';
import { hasRole } from '../../../utils/userRoles';
import MultiSelect from '../../formElements/MultiSelect';
import RadioButtons from '../../formElements/RadioButtons';

import app from '../../../app.module.css';
import form from '../../../commonStyles/formStyles.module.css';
import local from './appointmentsAdmin.module.css';

const InitialAppointmentConfiguration = ({
    constants,
    acceptedRoles,
    errors,
    clearError,
    keys,
    onUpdateConstants
}) => {
    // STORE STATE
    const roles = useSelector((state) => state.entities.userService.loggedInUser.roles);
    const includedFieldsInInitialAppointment = useSelector(
        (state) => state.entities.directusService.includedFieldsInInitialAppointment
    );

    const onUpdateDisplayInitialAppointment = (option) => {
        if (!option) clearError('initialAppointmentFields');
        onUpdateConstants('displayInitialAppointmentAccordion', option);
    };

    // RENDER
    return (
        <div className={local.appointmentsSection}>
            <h2 className={app.sectionHeading}>Initial Appointment Configuration</h2>
            <div className={form.formSection}>
                <div className={form.formColumn}>
                    <RadioButtons
                        id="displayInitialAppointmentAccordion"
                        label="Display Initial Appointment Accordion"
                        disabled={!hasRole(acceptedRoles, roles)}
                        value={constants.displayInitialAppointmentAccordion || false}
                        onChange={onUpdateDisplayInitialAppointment}
                    />
                </div>
                <div className={form.formColumn}>
                    <RadioButtons
                        id="requirePoNumberBeforeAppointmentInitialAttended"
                        label="PO Number Required for Initial Appointment Attendance"
                        disabled={!hasRole(acceptedRoles, roles)}
                        value={constants.requirePoNumberBeforeAppointmentInitialAttended || false}
                        onChange={(option) =>
                            onUpdateConstants(
                                'requirePoNumberBeforeAppointmentInitialAttended',
                                option
                            )
                        }
                    />
                </div>
            </div>
            <div className={form.formSection}>
                <div className={form.formColumn}>
                    <MultiSelect
                        id="initialAppointmentFields"
                        key={keys.initialAppointmentFields}
                        disabled={!hasRole(acceptedRoles, roles)}
                        label={'Included Fields in Initial Appointment'}
                        mandatory={constants.displayInitialAppointmentAccordion}
                        placeholder="Select included fields in initial appointment..."
                        menuItems={includedFieldsInInitialAppointment || []}
                        preSelectedIds={constants?.initialAppointmentFields}
                        preSelects={constants.initialAppointmentFields?.map((el) =>
                            getObjFromId(includedFieldsInInitialAppointment, el)
                        )}
                        error={errors.initialAppointmentFields}
                        onChange={(chosenIds) =>
                            onUpdateConstants('initialAppointmentFields', chosenIds)
                        }
                    />
                </div>
            </div>
        </div>
    );
};

InitialAppointmentConfiguration.propTypes = {
    constants: PropTypes.object,
    acceptedRoles: PropTypes.arrayOf(PropTypes.string),
    errors: PropTypes.object,
    clearError: PropTypes.func,
    keys: PropTypes.object,
    onUpdateConstants: PropTypes.func
};

export default InitialAppointmentConfiguration;
